import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { isError } from "../../../helpers/Error"
import HttpClient from "../../../helpers/HttpClient"
import { SearchPayload } from "../../../search/SearchPayload"
import SearchService from "../../../search/SearchService"
import SearchTotals, { SearchTotalsDto } from "../../../search/SearchTotals"
import { StockDocumentItemsResult } from "../models/stockDocumentItemResult"

export const OBJECT_TYPE = "inventory-stock-documents"

type StockDocumentListingSearchPayload = Omit<SearchPayload, "fields" | "lightResult" | "objects">


export class StockDocumentListingService {
    static searchTotalsHttpClient: HttpClient<SearchTotals,
        SearchTotalsDto> = new HttpClient<SearchTotals, SearchTotalsDto>(SearchTotals)

    static transformIntoSearchPayload(payload: StockDocumentListingSearchPayload) {
        const { filters: availableFilters, fields } = SearchService.getTotalsFiltersAndFields({
            typeOfSearch: OBJECT_TYPE
        })

        const transformedPayload = SearchService.getSearchPostData(
            payload.filters, 
            OBJECT_TYPE, 
            availableFilters, 
            undefined, 
            [OBJECT_TYPE], 
            payload.totals || [], 
            fields, 
            payload.keywords,
        )

        transformedPayload.filters = { ...payload.additionalFilters, ...transformedPayload.filters }
        return {
            ...payload,
            ...transformedPayload,
        }
    }

    static async findStockDocuments(payload: StockDocumentListingSearchPayload): Promise<StockDocumentItemsResult> {
        const res = await AppContext.getApiClient().post("/listing/search", StockDocumentListingService.transformIntoSearchPayload(payload))
        if (res.error) {
            throw new Error(res.error.message)
        } 

        return res as StockDocumentItemsResult
    }

    static async findStockDocumentsTotals(payload): Promise<SearchTotals> {
        const res = await this.searchTotalsHttpClient.post(
            "/listing/search-totals",
            StockDocumentListingService.transformIntoSearchPayload(payload)
        )

        if (isError(res)) {
            throw new Error(res.message)
        } 

        return res as SearchTotals
    }
}


// WEBPACK FOOTER //
// ./src/state/listing/inventory/service/service.ts